import React from 'react';
import { FormattedMessage } from '../../localization/index';
import './Loader.scss';

const Loader = () => (
  <div className="loader">
    <div className="loader-spinner">
      {Array.from(Array(12)).map((item, index) => (
        <div 
          key={`${index}-${item}`}
          style={{
            animationDelay: `-${1 / 12 * (12 - (index + 1))}s`,
            transform: `rotate(${360 / 12 * (index + 1)}deg)`,
          }}
        />
      ))}
    </div>
    <p>
      <FormattedMessage id="loading" defaultMessage="Please wait ..." />
    </p>
  </div>
);

export default Loader;
